export default {
    messages: {
        ui: {
            "blockTunes": {
                "toggler": {
                    "Click to tune": "Нажмите, чтобы настроить",
                    "or drag to move": "или перетащите"
                },
            },
            "inlineToolbar": {
                "converter": {
                    "Convert to": "Конвертировать в"
                }
            },
            "toolbar": {
                "toolbox": {
                    "Add": "Добавить",
                    "Filter": "",
                    "Nothing found": "Ничего не найдено"
                }
            }
        },
        toolNames: {
            "Heading": "Заголовок",
            "Text": "Параграф",
            "Link": "Ссылка",
            "Bold": "Полужирный",
            "Italic": "Курсив",
            "Marker": "Маркер",
            "List": "Список",
            "Delimiter": "Разделитель",
            "Warning": "Примечание",
            "Attachment": "Вложение",



            "Quote": "Цитата",
            "Code": "Код",

            "Raw HTML": "HTML-фрагмент",
            "Table": "Таблица",
            "InlineCode": "Моноширинный",
        },

        tools: {
            "warning": {
                "Message": "Сообщение",
            },
            "link": {
                "Add a link": "Вставьте ссылку"
            },
            "attachment": {
                "Select file to upload": "Выберите файл для загрузки"
            },

            "stub": {
                'The block can not be displayed correctly.': 'Блок не может быть отображен'
            }
        },
        blockTunes: {
            "delete": {
                "Delete": "Удалить"
            },
            "moveUp": {
                "Move up": "Переместить вверх"
            },
            "moveDown": {
                "Move down": "Переместить вниз"
            }
        },
    }
}